import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSim = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 4.0008)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M22 0C23.1046 0 24 0.895431 24 2V8.45312C24 9.44819 23.6293 10.4082 22.96 11.1445L19.7354 14.6904C18.9774 15.5242 17.9032 15.9999 16.7764 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 3.22128e-08 2 0H22ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V14C1.5 14.2761 1.72386 14.5 2 14.5H16.7764C17.4802 14.4999 18.152 14.203 18.626 13.6816L21.8496 10.1357L21.998 9.95703C22.3226 9.52557 22.5 8.99779 22.5 8.45312V2C22.5 1.72386 22.2761 1.5 22 1.5H2ZM11 3C12.1046 3 13 3.89543 13 5V11C13 12.0357 12.2128 12.887 11.2041 12.9893L11 13H5L4.7959 12.9893C3.85435 12.8938 3.1062 12.1457 3.01074 11.2041L3 11V5C3 3.89543 3.89543 3 5 3H11ZM5 4.5C4.72386 4.5 4.5 4.72386 4.5 5V11C4.5 11.2761 4.72386 11.5 5 11.5H11C11.2761 11.5 11.5 11.2761 11.5 11V5C11.5 4.72386 11.2761 4.5 11 4.5H5Z",
			fill: "currentColor"
		})
	})
});
export default SvgSim;
